import { FC } from "react";
import styles from "./TableHead.module.sass";

export const TableHead: FC = () => {
	const headTitles = [
		"Код",
		"Тип объекта",
		"Признак КИИ",
		"Дата предыдущего категорирования",
		"Наименование",
		"Активная итерация категорирования",
		"Статус итерации",
		"Назначение",
		"Связь с бизнес-процессами",
		"",
		"Код",
		"Ответственный",
		"Вид Владения Объектом",
		"Основание",
		"Сфера деятельности",
		"Создатель",
		"Дата регистрации в системе",
		"Внес последние изменения",
	];

	return (
		<thead className={styles.head}>
			<tr className={styles.row}>
				{headTitles.map((item, i) => (
					<th key={i} className={styles.item}>
						{item}
					</th>
				))}
				<th className={styles.item}></th>
			</tr>
		</thead>
	);
};
